import cx from 'classnames'
import styles from '../ActivitiesList.module.scss'
import AdventureCardPlaceholder from '../../adventures/AdventureCardPlaceholder'
import { Fragment } from 'react'
import NoResults from '../NoResults'
import Slider from 'react-slick'
import handleViewport from 'react-in-viewport'
import { useSelector } from 'react-redux'
import useActivitiesList from '../hooks/useActivitiesList'
import Proptypes from 'prop-types'
import get from 'lodash/get'
import ActivityCardDsl from './ActivityCardDsl'

import { isMobile } from '../../../utils'

export const settings = (beforeChangeHandler) => ({
  slidesToShow: isMobile() ? 2 : 4,
  slidesToScroll: isMobile() ? 1 : 4,
  lazyLoad: true,
  infinite: false,
  dots: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2.8,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
  beforeChange: beforeChangeHandler,
})

const getFilteredOtherTrips = (items, filters) => {
  const otherActiveFilters = filters.reduce((acc, el) => {
    const { isActive, othersFilter } = el
    return isActive ? [...acc, othersFilter] : acc
  }, [])
  return otherActiveFilters.length && items
    ? items.filter((trip) => otherActiveFilters.includes(trip.activityType))
    : items
}

function ActivitiesSlider(props, children) {
  const {
    inViewport,
    enterCount,
    forwardedRef,
    diveCenterId,
    isWidget,
    type,
    selectedCurrency,
  } = props
  const { other } = useSelector((state) => state.dslFiltersState)

  const { activities, isLoading } = useActivitiesList(
    type,
    selectedCurrency,
    diveCenterId,
    inViewport,
  )
  const placeholderItems = [...new Array(3)]
  const itemsLength = get(activities, 'length')

  if(!inViewport && enterCount === 0) {
    return <div
      className={cx('featured-slider', styles.featuredSlider)}
      ref={forwardedRef}
    >
      {placeholderItems.map((_, i) => {
        return <AdventureCardPlaceholder key={i} />
      })}
    </div>
  }

  // TODO: remove if dc other activities won't implement pagination
  // let sliderRef = useRef(null)
  // const paramsHandler = (current, next) => {
  //   if(!sliderRef.props) { return }
  //   if(next > current && sliderRef?.props?.children?.length <= total) {
  //     sliderRef.slickGoTo(params.offset)
  //     setTimeout(() => {
  //       setParams((prevState) => ({ limit: 4, offset: prevState?.offset + 4 }))
  //     }, 500)
  //   }
  // }
  const filteredTrips =
    other &&
    getFilteredOtherTrips(activities, other)?.map((trip) => (
      <ActivityCardDsl trip={trip} key={trip.id} isWidget={isWidget} />
    ))
  const isNoResults = !itemsLength || !filteredTrips.length

  return <div className={cx('featured-slider', styles.featuredSlider)}>
    <div id='other-activities-items'>
      <Fragment>
        {isNoResults && !isLoading ? (
          <NoResults />
        ) : (
          <Slider
            className={cx('slick-pt-custom', 'same-height', {
              'placeholder-animation': isLoading,
            })}
            {...settings()}
            // ref={(slider) => (sliderRef = slider)}
          >
            { isLoading
              ? placeholderItems.map((_, i) => {
                return <AdventureCardPlaceholder key={i} />
              })
              : filteredTrips
            }
          </Slider>
        )}
      </Fragment>
    </div>
  </div>
}

ActivitiesSlider.propTypes = {
  inViewport: Proptypes.bool,
  enterCount: Proptypes.number,
  forwardedRef: Proptypes.node,
  diveCenterId: Proptypes.number,
  isWidget: Proptypes.bool,
  wechatQr: Proptypes.string,
  selectedCurrency: Proptypes.string,
  type: Proptypes.string,
}

export default handleViewport(ActivitiesSlider, {}, { disconnectOnLeave: true })
